import { ICustomerConfig } from "@shared/modules/customer";
import { environment } from "../../environments/environment";

export const UserCustomerConfig: ICustomerConfig = {
    trackingParam: 't',
    useTokenInterceptor: false,
    useTrackingInterceptor: false,
    customerSpaceUrl: environment.customerSpaceUrl,
}